"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteStart = void 0;
class RouteStart {
    constructor(values) {
        Object.assign(this, values);
    }
    mapDDIs(ddiList) {
        return this.ddis.map((id) => ddiList.find((d) => d.id === id));
    }
    connectToDevice(devices) {
        return devices.find((d) => d.id === this.connectTo);
    }
}
exports.RouteStart = RouteStart;
